import { createTheme } from '@material-ui/core/styles'

export const GetMuiThemeEco = (columnTheme) => {
  return createTheme({
    palette: {
      primary: {
        main: 'rgba(62,152,76,1)',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
      },
    },
    overrides: {
      MUIDataTableHeadCell: {
        root: columnTheme,
        sortAction: {
          '& path': {
            color: 'rgba(62,152,76,1)',
            cursor: 'pointer',
          },
        },
        sortActive: {
          color: 'rgba(62,152,76,1)',
        },
      },
      MUIDataTableBodyCell: {
        root: {
          color: '#000',
          fontWeight: 400,
          whiteSpace: 'pre-wrap',
          textOverflow: 'ellipsis',
          cursor: 'pointer',
        },
      },
      MUIDataTableToolbar: {
        root: {
          background:
            columnTheme && columnTheme.toolbarBackground
              ? columnTheme.toolbarBackground
              : 'linear-gradient(90deg, rgba(62,152,76,1) 35%, rgba(0,134,126,1) 100%)',
          color: 'white',
        },
        icon: {
          color: columnTheme && columnTheme.toolbarBackground ? 'rgba(62,152,76,1)' : 'white',
          '&:hover': {
            color: columnTheme && columnTheme.toolbarBackground ? 'rgba(62,152,76,1)' : 'white',
          },
        },
      },
      MUIDataTableSearch: {
        root: {
          backgroundColor: 'white',
          color: 'white',
          '&:active': {
            color: 'white',
          },
        },
        searchIcon: {
          color: 'white',
          '&:active': {
            color: 'white',
          },
        },
        searchProps: {
          color: 'white',
        },
        clearIcon: {
          color: 'white',
        },
        searchText: {
          color: 'white',
        },
      },
      MUIDataTableFilter: {
        color: 'red',
      },
      MuiTableRow: {
        root: {
          width: '500px',
          cursor: 'pointer',
        },
      },
      MUIDataTable: {
        paper: {
          height: 'inherit',
          cursor: 'pointer',
        },
        responsiveScroll: {
          maxHeight: 'none',
          height: 'calc(100% - 128px)',
        },
      },
    },
  })
}

export const GetMuiThemeOem = (columnTheme) => {
  return createTheme({
    palette: {
      primary: {
        main: '#b70913',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
      },
    },
    overrides: {
      MUIDataTableHeadCell: {
        root: columnTheme,
        sortAction: {
          '& path': {
            color: '#b70913',
          },
        },
        sortActive: {
          color: '#b70913',
        },
      },
      MUIDataTableBodyCell: {
        root: {
          color: '#000',
          fontWeight: 400,
          whiteSpace: 'pre-wrap',
          textOverflow: 'ellipsis',
        },
      },
      MUIDataTableToolbar: {
        root: {
          background:
            columnTheme && columnTheme.toolbarBackground
              ? columnTheme.toolbarBackground
              : 'linear-gradient(90deg, #b70913 35%, #b70913 100%)',
          color: 'white',
        },
        icon: {
          color: columnTheme && columnTheme.toolbarBackground ? '#b70913' : 'white',
          '&:hover': {
            color: columnTheme && columnTheme.toolbarBackground ? '#b70913' : 'white',
          },
        },
      },
      MUIDataTableSearch: {
        root: {
          backgroundColor: 'white',
          color: 'white',
          '&:active': {
            color: 'white',
          },
        },
        searchIcon: {
          color: 'white',
          '&:active': {
            color: 'white',
          },
        },
        searchProps: {
          color: 'white',
        },
        clearIcon: {
          color: 'white',
        },
        searchText: {
          color: 'white',
        },
      },
      MUIDataTableFilter: {
        color: 'red',
      },
      MuiTableRow: {
        root: {
          width: '500px',
        },
      },
      MUIDataTable: {
        paper: {
          height: 'inherit',
        },
        responsiveScroll: {
          maxHeight: 'none',
          height: 'calc(100% - 128px)',
        },
      },
    },
  })
}
